export const omitter = (value: any) =>
	value === [] || value == null;

export const omitWithFalse = (value: any) =>
	value === [] || value === false || value == null;
